var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBank = function SvgIconBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.22 22.5c-.73 0-1.35-.26-1.86-.77a2.53 2.53 0 0 1-.76-1.86V16.5h3v-14h15v17.38c0 .72-.26 1.34-.77 1.85s-1.13.77-1.86.77zM18.97 21c.32 0 .58-.1.8-.32s.33-.49.33-.8V4h-12v12.5h9.75v3.38A1.093 1.093 0 0 0 18.97 21M9.6 8.5V7h9v1.5zm0 3V10h9v1.5zM6.2 21h10.15v-3H5.1v1.88c0 .31.1.58.32.8.22.21.48.32.78.32m0 0H5.1h11.25z"
  })));
};
export default SvgIconBank;